import { MatDialogConfig } from '@angular/material/dialog';
import { DIALOG_MESSAGES, DIALOG_TYPES, DialogScheduleModel, ROW_TYPES } from 'countable@model';

export class ScheduleUtil {
  static getRowType(rows: any[], row: any, rowIndex: number): any[] {
    rows.sort((a, b) => a.sortOrder - b.sortOrder);
    const resultRowIds: any[] = [];
    const checkedRows = rows.filter(r => r.isChecked);
    if (checkedRows.length > 0) {
      checkedRows.forEach(checked => {
        const index = rows.findIndex(r => r === checked);
        if (checked.type === ROW_TYPES.TEXT) {
          resultRowIds.push(checked);
          let i = index + 1;
          while (i < rows.length && rows[i].type === ROW_TYPES.SUBROW) {
            resultRowIds.push(rows[i]);
            i++;
          }
        } else {
          resultRowIds.push(checked);
        }
      });
    } else if (row) {
      resultRowIds.push(row);
      if (row.type === ROW_TYPES.TEXT) {
        let i = rowIndex + 1;
        while (i < rows.length && rows[i].type === ROW_TYPES.SUBROW) {
          resultRowIds.push(rows[i]);
          i++;
          if (i < rows.length && (rows[i].type !== ROW_TYPES.SUBROW)) {
            break;
          }
        }
      }
    }
    const remainingRows = structuredClone(rows).filter((obj1: any) => !structuredClone(resultRowIds).some((obj2: any) => (obj1.sortOrder === obj2.sortOrder)));
    remainingRows.sort((a, b) => a.sortOrder - b.sortOrder);
    remainingRows.forEach((row,index) => {
      if (row.type === ROW_TYPES.SUBTOTAL) {
        if (remainingRows[index - 1] && remainingRows[index - 1].type === ROW_TYPES.SUBTOTAL && row.type === ROW_TYPES.SUBTOTAL) {
          resultRowIds.push(row);
        } else if(index === 0) {
          resultRowIds.push(row);
        }
      }
    });

    return resultRowIds;
  }

  static groupByUuid(middleSectionDetails: any[], scheduleData: any []): any[] {
    const middleSectionData = JSON.parse(JSON.stringify(middleSectionDetails));
    const scheduleOriginalData = JSON.parse(JSON.stringify(scheduleData));
    scheduleOriginalData.forEach((schedule: any) => {
      middleSectionData.forEach((group: any) => {
        if (group?.children?.length) {
          group.children.forEach((child: any) => {
            if (child?.children?.length) {
              child.children.forEach((subChild: any) => {
                const parts = subChild?.chldid ? subChild?.chldid.split('.') : [];
                if (+parts[parts.length-1] == schedule?.groupLinkId) {
                  subChild.is_schedule_exits = 1;
                  subChild.schedule_name = `Schedule ${schedule?.sortOrder}`;
                  subChild.combined_id = schedule.uuid;
                  subChild.groupName = schedule.nameChange;
                  subChild.schedule_id = schedule.id;
                }
              });
            }
          });
        }
      });
    });
    return middleSectionData;
  };

  static groupBySchedule(middleSectionDetails: any[]): any[] {
    return middleSectionDetails.map((item: any) => {
      if (item?.children?.length) {
        item.children.forEach((child: any) => {
          if (child?.children?.length) {
            const groupMap = new Map();
            child.children.forEach((subGroup: any) => {
              if (subGroup.combined_id && subGroup?.groupName) {
                if (!groupMap.has(subGroup.combined_id)) {
                  groupMap.set(subGroup.combined_id, {
                    groupName: subGroup?.groupName,
                    combined_id: subGroup?.combined_id,
                    is_combined: subGroup?.is_combined,
                    is_schedule_exits: subGroup?.is_schedule_exits,
                    schedule_name: subGroup?.schedule_name,
                    children: []
                  });
                }
                groupMap.get(subGroup.combined_id).children.push(subGroup);
              } else {
                groupMap.set(subGroup.id, subGroup); // Handle children without `uuid`
              }
            });
            child.children = Array.from(groupMap.values());
          }
        });
      }
      return item;
    });
  };

  static getInputType(input: string): string {
    const longDatePattern = /^\w{4,}\s\d{1,2},?\s\d{4}$/;
    const shortDatePattern = /^\w{3}\s\d{1,2},?\s\d{4}$/;
    const yearPattern = /^\d{4}$/;

    if (longDatePattern.test(input)) {
      return 'long';
    } else if (shortDatePattern.test(input)) {
      return 'short';
    } else if (yearPattern.test(input)) {
      return 'year';
    } else {
      return null;
    }
  }

  static createSchedule(data: any, scheduleForm: any, subGroups:any) {
    let scheduleList = {
      groupName: data.type === DIALOG_TYPES.GROUP ? scheduleForm?.groupName : null,
      isCollapse: data.type === DIALOG_TYPES.GROUP ? scheduleForm?.orientation : false,
      isManual: data.type === DIALOG_TYPES.MANUAL,
      child: [{
        name: scheduleForm?.groupName,
        chldid: null,
        totalname: null,
        trialbal: [{
          trailbalanceid: null,
          accountname: '',
          Currbal: 0,
          Prevbal: 0
        }]
      }]
    };
    if (subGroups?.length) {
      scheduleList.child = [];
      subGroups.forEach((group: any) => {
        let subGroup = {
          name: group.name,
          chldid: group?.chldid,
          totalname: data.type === DIALOG_TYPES.GROUP ? group?.totalname : null,
          trialbal: []
        };
        const rows = group?.trialbal?.length ? group?.trialbal  : group.rows;
        rows.forEach((row: any, index: number) => {
          subGroup.trialbal.push({
            trailbalanceid: row.trailbalanceid,
            accountname: row.accountname,
            Currbal: row?.Currbal ? this.convertToNumber(row.Currbal) : 0,
            Prevbal: row?.Prevbal ? this.convertToNumber(row.Prevbal) : 0
          });
          if (index === rows.length - 1) {
            scheduleList.child.push(subGroup);
          }
        });
      });
    }
    return scheduleList;
  }

  static convertToNumber(value: any) {
    if (typeof value === 'number') {
      return Math.round(value);
    }
    if (value === '-' || value == null) {
      return 0;
    }
    const isNegative = value.includes('(');
    const cleanedValue = value.replace(/[(),]/g, '');
    return isNegative ? -Math.round(Number(cleanedValue)) : Math.round(Number(cleanedValue));
  }

  static createScheduleGroups(type:DIALOG_TYPES,totalLength: number, selectedSubGroup: any, isBSSch:boolean, isPreviousYear: boolean ) {
    const schedule = new DialogScheduleModel();
    schedule.type = type;
    schedule.selectedSchedule = {
      name: 'Schedule ' + (totalLength + 1),
      lineName: '',
      sortOrder: totalLength + 1,
      subGroups: selectedSubGroup?.subGroups,
      isValid: selectedSubGroup?.isValid,
      isAllChecked: true,
      isBSSch: isBSSch,
      isPreviousYear: isPreviousYear
    };
    const config: MatDialogConfig = new MatDialogConfig<any>();
    config.data = schedule;
    config.disableClose = true;
    return config;
  }

  static getGroupsFromGroupLinkId(groupList: any[], groupLinkIds: number[]){
    let list = [];
    if(groupList?.length && groupLinkIds.length){
      groupList.forEach((group: any) => {
        if (group?.children?.length) {
          group.children.forEach((child: any) => {
            if (child?.children?.length) {
              child.children.forEach((subChild: any) => {
                  const groupId = subChild?.chldid.split('.');
                  +groupId[groupId.length-1] && groupLinkIds.includes(+groupId[groupId.length-1]) ? list.push(subChild) : '';
              });
            }
          });
        }
      });
    }
    return list;
  }

  static getUpdatedRecordsForKey(array1: any[], array2: any[], key: string, checkKey: string): any[] {
    const updatedRecords: any[] = [];

    array1.forEach(record1 => {
      array2.forEach(record2 =>{
        if (record2[key] == record1[key] && record1[checkKey] !== record2[checkKey]) {
          updatedRecords.push({
            old: record1,
            new: record2
          });
        }
      });
    });

    return updatedRecords;
  }

  static onChangeMatCheckbox(list:any[]) {
    let leadSheetCode = null;
    let isSameLeadSheetCode = true;
    let isValid = true;
    let isCreateGroup = true;
    let subCategories = [];
    if (list?.length) {
      list.forEach(group => {
        if (group?.children?.length) {
          group.children.forEach((child: any) => {
            if (child?.children?.length) {
              child.children.forEach((subChild: any) => {
                let subCategory = {
                  name: subChild.name,
                  rows: [],
                  lsCode: '',
                  isChecked: true,
                  chldid: subChild?.chldid,
                  totalname: subChild?.totalname
                };
                isSameLeadSheetCode = (subChild?.checked && subChild?.is_schedule_exits == 1) ? false : isSameLeadSheetCode;
                if(subChild?.checked || (subChild?.trialbal?.length && subChild?.trialbal?.find((row: any) => row.checked))){
                  isValid = (subChild?.is_schedule_exits == 1 || !(subChild?.trialbal?.filter((row: any) => row.checked).length === subChild?.trialbal?.length) ||
                  subChild?.trialbal?.find((row: any) => row.trailbalanceid == 0)) ? false : isValid;
                }
                isCreateGroup = (subChild?.is_schedule_exits == 1 && subChild?.trialbal?.find((row: any) => row.checked)) ? false : isCreateGroup;
                if (subChild?.trialbal?.length) {
                  subChild?.trialbal.forEach((trialBal: any, index: number) => {
                    if (trialBal?.checked) {
                      if (isSameLeadSheetCode) {
                        if (!leadSheetCode) {
                          leadSheetCode = trialBal.leadsheet.split('-')[0];
                        } else {
                          isSameLeadSheetCode = (leadSheetCode == trialBal.leadsheet.split('-')[0]);
                        }
                      }
                      subCategory.lsCode = trialBal.leadsheet.split('-')[0];
                      subCategory.rows.push(trialBal);
                    }
                    if (subCategory.rows.length && index === subChild.trialbal.length - 1) {
                      subCategories.push(subCategory);
                    }
                  });
                }
              //   for existing schedules groups
                if(subChild?.children?.length){
                  subChild?.children.forEach((subRow: any) =>{
                    if(subRow?.checked || subRow?.trialbal?.find((row: any) => row.checked)){
                      isValid = (subRow?.is_schedule_exits == 1 || !(subRow?.trialbal?.filter((row: any) => row.checked).length === subRow?.trialbal?.length)) ?
                        false : isValid;
                    }
                    isCreateGroup = (subRow?.is_schedule_exits == 1 && subRow?.trialbal?.find((row: any) => row.checked)) ? false : isCreateGroup;
                  })
                }
              });
            }
          });
        }
      });
      isValid = subCategories?.length === 1 ? false : isValid;
    }
    return {
      subGroups: subCategories,
      isValid: isSameLeadSheetCode,
      disableCreateButtons: isValid,
      disableCreateGroup: isCreateGroup
    };
  }

  static getDeleteSubTotalConfig(){
    const schedule = new DialogScheduleModel();
    schedule.headerText = DIALOG_MESSAGES.HEADER_SUB_TOTAL_DELETE;
    schedule.subInfoText = DIALOG_MESSAGES.INFO_SUB_TOTAL_TEXT_DELETE;
    schedule.buttonCancelText = DIALOG_MESSAGES.BUTTON_SUB_TOTAL_CANCEL_TEXT;
    schedule.buttonConfirmText = DIALOG_MESSAGES.BUTTON_SUB_TOTAL_CONFIRM_TEXT;
    schedule.type = DIALOG_TYPES.DELETE;
    schedule.subHeaderText = DIALOG_MESSAGES.SUB_HEADER_SUB_TOTAL_DELETE;
    const config: MatDialogConfig = new MatDialogConfig<any>();
    config.data = schedule;
    config.disableClose = true;
    return config;
  }

  static getGroupIdByTbId(tbId: any[], groupList: any[], schedulesGroupId: any[]): any {
    let groupByTb: any[] = [];
    groupList.forEach((group: any) =>{
      group?.children?.forEach((child: any) => {
        if (child?.children?.length) {
          child.children.forEach((subChild: any) => {
            const parts = subChild?.id ? subChild?.id.split('.') : [];
            if (schedulesGroupId.includes(+parts[0]) && subChild?.trialbal?.length) {
              const filteredArray = tbId.filter((item1: any) =>
                subChild?.trialbal.some((item2: any) => item1.trailbalanceid == item2.trailbalanceid)
              );
              groupByTb.push(...filteredArray.map((tb: any) => tb?.trailbalanceid));
            }
          });
        }
      })
    })
    return groupByTb;
  }

  static getOrCreateTabId(key: string): string {
    let tabId = sessionStorage.getItem(key);
    if (!tabId) {
      tabId = `${Date.now()}-${Math.floor(Math.random() * 1000000)}`;
      sessionStorage.setItem(key, tabId);
    }
    return tabId;
  }

  static mergeByIdAndUniqueRows(arr1: any[], arr2: any[]) {
    const resultMap = new Map<number, any>();

    [...arr1, ...arr2].forEach(entry => {
      if (!resultMap.has(entry.id)) {
        resultMap.set(entry.id, { id: entry.id, rows: [...entry.rows] });
      } else {
        const existing = resultMap.get(entry.id);

        // Merge rows, avoid duplicates by sortOrder
        const allRows = [...existing.rows, ...entry.rows];
        const rowMap = new Map<number, any>();
        allRows.forEach(row => rowMap.set(row.sortOrder, row));

        existing.rows = Array.from(rowMap.values()).sort((a, b) => a.sortOrder - b.sortOrder);
      }
    });

    return Array.from(resultMap.values());
  }

  static getRowTypeFsTable(rows: any[], row: any, rowIndex: number): any[] {
    const resultRowIds: any[] = [];
    const checkedRows = rows.filter(r => r.isChecked);
    if (checkedRows.length > 0) {
      checkedRows.forEach(checked => {
        const index = rows.findIndex(r => r === checked);
        if (checked.rowId === 'textonly') {
          resultRowIds.push(checked);
          let i = index + 1;
          while (i < rows.length && rows[i].rowId.includes('_subrow')) {
            resultRowIds.push(rows[i]);
            i++;
          }
        } else {
          resultRowIds.push(checked);
        }
      });
    } else if (row) {
      resultRowIds.push(row);
      if (row.rowId === 'textonly') {
        let i = rowIndex + 1;
        while (i < rows.length && rows[i].rowId.includes('_subrow')) {
          resultRowIds.push(rows[i]);
          i++;
          if (i < rows.length && !(rows[i].rowId.includes('_subrow'))) {
            break;
          }
        }
      }
    }
    const remainingRows = structuredClone(rows).filter((obj1: any) => !structuredClone(resultRowIds).some((obj2: any) => (obj1.sortOrder === obj2.sortOrder)));
    remainingRows.forEach((row,index) => {
      if (row.rowId === 'subtotal') {
        if (remainingRows[index - 1] && remainingRows[index - 1].rowId === 'subtotal' && row.rowId === 'subtotal') {
          resultRowIds.push(row);
        } else if(index === 0 && row.rowId === 'subtotal') {
          resultRowIds.push(row);
        }
      }
    });

    return resultRowIds;
  }



}
